import { useContext } from 'react';
import { createContext } from 'react';

import { ProductBrandProps } from '../@types/ProductBrandProps';

export const ProductBrandContext = createContext<ProductBrandProps>({} as ProductBrandProps);

ProductBrandContext.displayName = 'ProductBrand';

const ProductBrandProvider = (props: ProductBrandProps) => (
	<ProductBrandContext.Provider value={props}>{props.children}</ProductBrandContext.Provider>
);

export const useProductBrand = () => {
	const context = useContext(ProductBrandContext);

	return context;
};

export default ProductBrandProvider;
